import { Build, DeviceHub } from "@material-ui/icons"
import DescriptionIcon from "@material-ui/icons/Description"
import SettingsRemoteOutlinedIcon from "@material-ui/icons/SettingsRemoteOutlined"
import ShuffleIcon from "@material-ui/icons/Shuffle"
import Account from "mdi-material-ui/Account"
import AccountDetails from "mdi-material-ui/AccountDetails"
import Apps from "mdi-material-ui/Apps"
import Domain from "mdi-material-ui/Domain"
import Home from "mdi-material-ui/Home"
import KeyVariant from "mdi-material-ui/KeyVariant"
import RadioTower from "mdi-material-ui/RadioTower"
import Rss from "mdi-material-ui/Rss"
import Server from "mdi-material-ui/Server"
import Tune from "mdi-material-ui/Tune"

import SessionStore from "../stores/SessionStore"

export const ADMIN_NAV_ITEMS = [
  { to: "/dashboard", icon: Home, label: "Dashboard", match: "exact" },
  { to: "/network-servers", icon: Server, label: "Frequency plans" },
  { to: "/gateway-profiles", icon: RadioTower, label: "Gateway-profiles" },
  { to: "/device-profiles", icon: Tune, label: "Device-profiles" },
  { to: "/organizations", icon: Domain, label: "Organizations", match: "exact" },
  { to: "/users", icon: Account, label: "All users" },
  { to: "/api-keys", icon: KeyVariant, label: "API keys" },
  { to: "/diagnostics", icon: SettingsRemoteOutlinedIcon, label: "LoRaWAN Logger" },
  { to: "/logs", icon: DescriptionIcon, label: "Logs", match: "exact" },
  {
    to: "/tools/export",
    icon: Build,
    label: "Tools",
    isActive: (pathname) => pathname.startsWith("/tools"),
  },
]

export const NOAUTH_NAV_ITEMS = [
  { to: "/", icon: Home, label: "BS Check", titleAccess: "Home", alwaysShowText: true, match: "exact" },
]

export function getOrgNavItems({ organization, isGlobalAdmin }) {
  const organizationId = organization.id

  return [
    {
      to: "/organizations",
      icon: Domain,
      label: "Organizations",
      match: "exact",
      isHidden: SessionStore.isAdmin() || !SessionStore.organizations || SessionStore.organizations.length <= 1,
    },
    { to: `/organizations/${organizationId}`, icon: Home, label: "Dashboard", match: "exact" },
    { to: "/diagnostics", icon: SettingsRemoteOutlinedIcon, label: "LoRaWAN Logger", isHidden: SessionStore.isAdmin() },
    { to: `/organizations/${organizationId}/service-profiles`, icon: AccountDetails, label: "Service-profiles" },
    { to: `/organizations/${organizationId}/applications`, icon: Apps, label: "Application Servers" },
    { to: `/organizations/${organizationId}/as-routing-profiles`, icon: ShuffleIcon, label: "AS routing profiles" },
    { to: "/device-profiles", icon: Tune, label: "Device-profiles", isHidden: isGlobalAdmin },
    { to: `/organizations/${organizationId}/devices`, icon: DeviceHub, label: "Devices" },
    { to: `/organizations/${organizationId}/gateways`, icon: RadioTower, label: "Gateways", isHidden: !organization.canHaveGateways },
    { to: `/organizations/${organizationId}/multicast-groups`, icon: Rss, label: "Multicast-groups" },
    { to: `/organizations/${organizationId}/api-keys`, icon: KeyVariant, label: "API keys", adminOnly: true },
    { to: `/organizations/${organizationId}/users`, icon: Account, label: "Users", adminOnly: true },
    {
      to: `/organizations/${organizationId}/logs`,
      icon: DescriptionIcon,
      label: "Logs",
      isHidden: !SessionStore.isAdmin() && !SessionStore.isOrganizationAdmin(organizationId),
    },
  ].filter((item) => !item.isHidden)
}
